// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__OmkeX","title":"Header_title__2mDLh","side":"Header_side__2eunw"};